const COLUMN_TYPES = {
  MONTH: 0
};

export { COLUMN_TYPES };
